import React, { ReactNode } from "react";

import { Text, StyleSheet, View } from "@react-pdf/renderer";

import { format } from "date-fns";

import { ReportAnswer } from "../../../../../graphql/types";

const styles = StyleSheet.create({
  answerRootContainer: {
    display: "flex",
    flexDirection: "column",
    fontSize: "3.7mm",
    color: "#4C566A",
    border: "1pt solid #E5E9F0",
    borderRadius: "4pt",
  },
  answerHeaderContainer: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: "3mm",
    paddingHorizontal: "6mm",
    color: "#4C566A",
    backgroundColor: "#f8f9fb",
    borderBottom: "1pt solid #E5E9F0",
  },
  answerUserName: {
    color: "#3d5676",
  },
  answerDate: {
    color: "#828997",
    fontSize: "3mm",
  },
  answerContainer: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    paddingVertical: "4mm",
    paddingHorizontal: "6mm",
    color: "#3B4252",
  },
  commentContainer: {
    paddingHorizontal: "6mm",
    paddingBottom: "4.2mm",
  },
  commentHeader: {
    color: "#828997",
    fontSize: "3mm",
  },
  comment: {
    display: "flex",
    flexWrap: "wrap",
    fontSize: "3mm",
    color: "#434C5E",
  },
  noComment: {
    fontStyle: "italic",
  },
});

type ReportAnswerPDFProps = {
  answer: ReportAnswer;
  answerAs: ReactNode;
  withComment?: boolean;
  comment?: ReactNode;
  t: (id: any, options?: {}) => React.ReactNode;
};

const ReportAnswerPDF: React.FC<ReportAnswerPDFProps> = ({
  answer,
  answerAs,
  withComment,
  comment,
  t,
}) => (
  <View style={styles.answerRootContainer}>
    <View style={styles.answerHeaderContainer}>
      <Text style={styles.answerUserName}>{answer.user.name}</Text>
      <Text style={styles.answerDate}>
        {format(new Date(answer.updatedAt), t("dateFormat") as string)}
      </Text>
    </View>
    <View style={styles.answerContainer}>{answerAs}</View>
    {withComment && (
      <View style={styles.commentContainer}>
        <Text style={styles.commentHeader}>
          {t("reports.comments") as string}:
        </Text>
        <Text style={styles.comment}>
          {comment ? comment : (t("reports.noComments") as string)}
        </Text>
      </View>
    )}
  </View>
);

export default ReportAnswerPDF;
